import { render, staticRenderFns } from "./TaskBarChart.vue?vue&type=template&id=9b7f60be"
import script from "./TaskBarChart.vue?vue&type=script&lang=js"
export * from "./TaskBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports